import React,{useState} from 'react';
import * as S from './RnRPopup.styles';
import RnRUserReviewBlock from '../RnRUserReviewBlock/RnRUserReviewBlock';
import RnRRatingRange from '../RnRRatingRange/RnRRatingRange';
import CustomCheckbox from '../../../../../../stories/core-components/Checkbox/Checkbox';
import {ratingColorConfig} from './../../../../../containers/Common/config'
import ContentUnavailable from './../../SrpErrorStates/ContentUnavailable';
import {SEAT_LAYOUT} from './../../../../../config/messages';
import Loader from './../../SrpLoader/Loader/Loader';

const RnRPopup = (props) => {
  const {data,bid,onClose,busDetailsInfo} = props;
  const {error,isLoading} = data;

  if(error){
    return (
   <S.RnRPopupOverlay>
    <S.RnRPopupWrap>
      <S.CloseButton onClick={props.onClose}>X Close</S.CloseButton>
      <S.RnRPopup>
      <ContentUnavailable text={SEAT_LAYOUT.RATING_REVIEW_ERROR}></ContentUnavailable>
  
      </S.RnRPopup>
  </S.RnRPopupWrap>
    </S.RnRPopupOverlay>   )
    }
    if(isLoading){
      return (<S.RnRPopupOverlay>
      <S.RnRPopupWrap>
        <S.CloseButton onClick={props.onClose}>X Close</S.CloseButton>
        <S.RnRPopup>
        <Loader></Loader>
        </S.RnRPopup>
    </S.RnRPopupWrap>
      </S.RnRPopupOverlay>   )
     
    }
   
const {positive,critical,all,totalReviewsCount} = data.data;
const ratings = busDetailsInfo.reviews.ratings;
const totalRatingCount = ratings.totalRatings;
const overallRating = ratings.averageRating;
const ratingInfo = function(){
  let data={}
  for(let i in ratings.ratings_percentage){
    data[i] ={percentage:ratings.ratings_percentage[i],count:0}
  }
return data;

}();

const [selectedFilters,setSelectedFilters] = useState({positive:(positive.length > 0),critical:(critical.length>0)}); 
let reviewData = [];
for(let i in selectedFilters){
  if(selectedFilters.hasOwnProperty(i)){
   
  }
}
if((selectedFilters['positive'] && selectedFilters['critical']) || (!selectedFilters['positive'] && !selectedFilters['critical'])){
  reviewData = all
}else{
  if(selectedFilters['positive']){
    reviewData = positive;
  }else if(selectedFilters['critical']){
    reviewData = critical;
  }
}

const userReviewView = getUserReviewView(reviewData,bid);
  return(
  <S.RnRPopupOverlay>
    <S.RnRPopupWrap>
      <S.CloseButton onClick={onClose}>X Close</S.CloseButton>
      <S.RnRPopup>
        <S.RnRLeftContent>
          <S.RatingRangeWrap>
            <RnRRatingRange ratingInfo={ratingInfo} overallRating={overallRating} totalReviewsCount={totalReviewsCount} totalRatingCount={totalRatingCount}/>

          </S.RatingRangeWrap>
          <S.FilterBlock>
            <S.FilterHeader>Filter options</S.FilterHeader>
            <S.FilterList>
              {(positive && positive.length)?  
        <div key={`${bid}positive`}>
      <CustomCheckbox onClickCb={()=>{
        const filters = Object.assign({},selectedFilters);
        filters['positive'] = !filters['positive'];
            setSelectedFilters(filters);

        }} checked={selectedFilters['positive']} title="Positive Reviews" />
    </div> :null}
 {(critical && critical.length) ?
        <div key={`${bid}critical`}>
      <CustomCheckbox onClickCb={()=>{
           const filters = Object.assign({},selectedFilters);
           filters['critical'] = !filters['critical'];
               setSelectedFilters(filters);
   
    }} checked={selectedFilters['critical']} title="Critical Reviews" />
    </div> :null}
 

            </S.FilterList>
          </S.FilterBlock>
        </S.RnRLeftContent>
        <S.RnRRightContent>
          {userReviewView}
        </S.RnRRightContent>
      </S.RnRPopup>
    </S.RnRPopupWrap>
  </S.RnRPopupOverlay>
);
}
export default RnRPopup;
function getUserReviewView(data,bid){
  var view =[];
  for(let i in data){
    if(data.hasOwnProperty(i)){
      const {lastName,totalRating,firstName,reviewContent,departureDate,liked,operatorReply,operatorReplyDate} = data[i];
      const departureDateArr =  departureDate.split("-")
      const date = departureDateArr[0];
      const month = departureDateArr[1];
      const year = departureDateArr[2];
    
      view.push(
      <S.ReviewBlockWrap key={firstName+departureDate+lastName+bid}>
            <RnRUserReviewBlock
              ratingcolor={ratingColorConfig[Math.round(totalRating)]}
              ratingcount={totalRating}
              username={`${firstName} ${lastName}`}
              reviewdate={`${date}-${month}-${year}`}
              reviewcontent={reviewContent}
              liked={liked}
              operatorReply={operatorReply}
              operatorReplyDate={operatorReplyDate}
            
            />
          </S.ReviewBlockWrap>
        
    )
      
     
    }
}
return view;
}
